import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(0.5, 0, 0.5, 1.5),
      minHeight: 36,
    },
    title: {
      flex: 1,
    },
    settingsButton: {
      marginLeft: 'auto',
      color: COLORS.gray.gray30,
    },
  }),
  { name: 'HeaderListItem' }
);
